import useUserBranches from '../queries/useUserBranches';

const useMainStockLocation = () => {
    const { branches, locationCode } = useUserBranches();

    return branches.find(({ isMainStock }) => isMainStock)?.id || locationCode;
};

export default useMainStockLocation;
